import { render } from "./CardApiForm.vue?vue&type=template&id=0bb23168"
import script from "./CardApiForm.vue?vue&type=script&lang=js"
export * from "./CardApiForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__